(function () {
  const rootSel = 'product-block';
  function setVariant(root, variantId, unavailable) {
    root.querySelectorAll('[data-role="variant-id"]').forEach(inp => {
      inp.value = variantId;
    });
    const atc = root.querySelector('[data-role="atc"]');
    const notify = root.querySelector('[data-role="notify"]');
    if (atc && notify) {
      if (unavailable) {
        atc.hidden = true;
        notify.hidden = false;
        const btn = notify.querySelector('.gw-button-widget');
        if (btn) {
          btn.setAttribute('data-variant-id', variantId);
        }
      } else {
        notify.hidden = true;
        atc.hidden = false;
      }
    }
  }
  document.addEventListener('click', function (ev) {
    const swatch = ev.target.closest('.product-block-options__item');
    if (!swatch) return;
    const root = swatch.closest(rootSel);
    if (!root) return;
    const variantId = swatch.getAttribute('data-variant-id');
    if (!variantId) return;
    const isUnavailable = swatch.classList.contains('product-block-options__item--unavailable');
    setVariant(root, variantId, isUnavailable);
  });
  document.querySelectorAll(rootSel).forEach(root => {
  });
})();
(function () {
  if (window.__CST_ATC_CARDS__) return;
  window.__CST_ATC_CARDS__ = true;
  function getLogoAreaTarget() {
    const sels = [
      '#pageheader .logo-area.container.container--no-max',
      '#pageheader .logo-area.container',
      '#pageheader .logo-area'
    ];
    for (const s of sels) {
      const el = document.querySelector(s);
      if (el) return el;
    }
    return null;
  }
  function buildAddedNotificationMarkup(titleText) {
    const el = document.createElement('added-notification');
    el.className = 'added-notification';
    el.setAttribute('data-product-title', titleText || 'Produto');
    el.innerHTML = `
      <div class="added-notification__message-area">
        <div class="added-notification__message-title">${titleText || 'Produto'}</div>
        <div class="added-notification__message-text underline-child">
          Adicionado ao seu <a href="/cart">Carrinho</a>
        </div>
      </div>
      <div class="added-notification__button-area">
        <button type="button" class="added-notification__close" aria-label="Fechar">
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none"
               stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"
               class="icon feather feather-x" aria-hidden="true" focusable="false" role="presentation">
            <path d="M18 6 6 18M6 6l12 12"></path>
          </svg>
        </button>
      </div>
    `;
    el.querySelector('.added-notification__close')?.addEventListener('click', () => el.remove());
    setTimeout(() => el.remove(), 4500);
    return el;
  }
  function formatMoney(cents) {
    if (window.Shopify && typeof Shopify.formatMoney === 'function') {
      try { return Shopify.formatMoney(cents, window.Shopify.money_format); } catch (_) {}
    }
    try { return (cents/100).toLocaleString('pt-BR', {style:'currency', currency:'BRL'}); }
    catch (_) { return 'R$ ' + (cents/100).toFixed(2).replace('.', ','); }
  }
function htmlToNode(html) {
  const doc = new DOMParser().parseFromString(html, 'text/html');
  return doc.body.firstElementChild || null;
}
function ensureDrawerSectionInDOM(drawerSectionHtml) {
  let drawerSection = document.getElementById('shopify-section-cart-drawer');
  if (drawerSection) return drawerSection;
  const doc = new DOMParser().parseFromString(drawerSectionHtml, 'text/html');
  const freshSection = doc.getElementById('shopify-section-cart-drawer');
  if (!freshSection) return null;
  drawerSection = freshSection.cloneNode(true);
  document.body.appendChild(drawerSection);
  return drawerSection;
}
function updateHeaderCartCount(count) {
  const n = Number(count) || 0;
  document.querySelectorAll('.cart-link__icon').forEach(icon => {
    let badge = icon.querySelector('.cart-link__count');
    if (!badge) {
      badge = document.createElement('span');
      badge.className = 'cart-link__count';

      const svg = icon.querySelector('svg');
      if (svg && svg.nextSibling) svg.parentNode.insertBefore(badge, svg.nextSibling);
      else icon.appendChild(badge);
    }
    badge.textContent = String(n);
    if (n > 0) {
      badge.style.display = '';
      badge.removeAttribute('hidden');
      badge.classList.remove('is-empty', 'hidden', 'visually-hidden');
      badge.setAttribute('aria-hidden', 'false');
    } else {

      badge.style.display = 'none';
      badge.setAttribute('aria-hidden', 'true');
    }
  });
  document.querySelectorAll('[data-cart-count], #CartCount, .cart-count-bubble__count, .header-cart-count, .cart-count, .header-cart__count')
    .forEach(el => {
      el.textContent = String(n);
      if (n > 0) {
        el.style.display = '';
        el.removeAttribute('hidden');
        el.setAttribute('aria-hidden', 'false');
      } else {
        el.style.display = 'none';
        el.setAttribute('aria-hidden', 'true');
      }
    });
}
async function refreshCartUI() {
  let cart = null;
  try {
    cart = await fetch('/cart.js', { headers: { 'Accept': 'application/json' } }).then(r => r.json());
  } catch (e) {}
  if (cart) {
    updateHeaderCartCount(cart.item_count);
    const total = (window.Shopify && Shopify.formatMoney)
      ? Shopify.formatMoney(cart.total_price, window.Shopify.money_format)
      : (cart.total_price/100).toLocaleString('pt-BR', { style:'currency', currency:'BRL' });

    document.querySelectorAll('[data-cart-total],[data-cart-subtotal],.header-cart-total,.cart-total-amount')
      .forEach(el => (el.textContent = total));
  }
  const root = (window.Shopify && Shopify.routes && Shopify.routes.root) ? Shopify.routes.root : '/';
  const sections = ['cart-icon-bubble', 'cart-drawer-custom'];
  let json;
  try {
    json = await fetch(`${root}?sections=${encodeURIComponent(sections.join(','))}`, {
      headers: { 'Accept': 'application/json' }
    }).then(r => r.json());
  } catch (e) { return; }
  const iconHtml = json['cart-icon-bubble'];
  if (iconHtml) {
    const currentIconSection = document.getElementById('shopify-section-cart-icon-bubble');
    if (currentIconSection) {
      const doc = new DOMParser().parseFromString(iconHtml, 'text/html');
      const fresh = doc.getElementById('shopify-section-cart-icon-bubble');
      if (fresh) currentIconSection.replaceWith(fresh);
    } else {
      const iconEl = document.querySelector('cart-icon-bubble, .cart-count-bubble');
      if (iconEl) iconEl.outerHTML = iconHtml;
    }
  }
  const drawerHtml = json['cart-drawer-custom'];
  if (drawerHtml) {
    ensureDrawerSectionInDOM(drawerHtml);
    const drawerEl = document.querySelector('cart-drawer-custom');
    if (drawerEl && typeof drawerEl.updateFromCartChange === 'function') {
      drawerEl.updateFromCartChange(drawerHtml);
    } else {
      const currentDrawerSection = document.getElementById('shopify-section-cart-drawer');
      if (currentDrawerSection) {
        const doc = new DOMParser().parseFromString(drawerHtml, 'text/html');
        const fresh = doc.getElementById('shopify-section-cart-drawer');
        if (fresh) currentDrawerSection.replaceWith(fresh);
      }
    }
  }
  ['cart:updated','cart:refresh','theme:cart:change'].forEach(evt => {
    try { document.dispatchEvent(new CustomEvent(evt, { detail: cart })); } catch(e){}
  });
}
  document.addEventListener('submit', async (ev) => {
    const form = ev.target.closest('.product-card-atc-form');
    if (!form) return;
    const isPDP = document.body.classList.contains('template-product') || location.pathname.includes('/products/');
    if (isPDP) return;
    ev.preventDefault();
    const btn = form.querySelector('button[type="submit"]');
    btn?.setAttribute('disabled', 'disabled');
    try {
      const fd = new FormData(form);
      const res = await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Accept': 'application/json' },
        body: fd
      });
      if (!res.ok) throw await res.json();
      const item = await res.json();
      await refreshCartUI();
      const target = getLogoAreaTarget();
      if (target) {
        const prev = target.querySelector('added-notification');
        if (prev) prev.remove();
        const note = buildAddedNotificationMarkup(item.product_title || item.title || 'Produto');
        target.appendChild(note);
      }
    } catch (err) {
      console.error('ATC error', err);
    } finally {
      btn?.removeAttribute('disabled');
    }
  });
})();
(function () {
  document.addEventListener('click', function (ev) {
    const btn = ev.target.closest('.product-card-notify .gw-button-widget');
    if (!btn) return;
    const productHandle = btn.getAttribute('data-product-handle');
    const variantId = btn.getAttribute('data-variant-id') || '';
    const isPDP = document.body.classList.contains('template-product') || window.location.pathname.indexOf('/products/') !== -1;
    if (!isPDP) {
      ev.preventDefault();
      const qp = new URLSearchParams();
      qp.set('open_notify', '1');
      if (variantId) qp.set('variant', variantId);
      const rootPrefix = (window.Shopify && Shopify.routes && Shopify.routes.root) ? Shopify.routes.root : '/';
      const url = `${rootPrefix}products/${productHandle}?${qp.toString()}`;
      window.location.href = url;
      return;
    }
    const tryClick = () => {
      const realBtn = document.querySelector('#this-button-area .gw-button-widget');
      if (realBtn) { realBtn.click(); return true; }
      return false;
    };
    ev.preventDefault();
    if (tryClick()) return;
    const start = Date.now();
    const timer = setInterval(() => {
      if (tryClick() || Date.now() - start > 6000) clearInterval(timer);
    }, 150);
  });
})();